import { Form } from 'formik';
import { FC, ReactNode } from 'react';

import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Button } from 'src/general/components/Button/Button';
import { FormikInput } from 'src/general/components/forms/FormikInput/FormikInput';

import styles from './FinanceEnquiryForm.module.scss';

type FinanceEnquiryFormProps = {
  isOpen: boolean;
  handleSubmit: () => void;
  isSubmitting: boolean;
  onClose: () => void;
  microcopy: {
    formHeader: ReactNode;
    detailSectionTitle: ReactNode;
    messageLabel: ReactNode;
    firstNameLabel: ReactNode;
    lastNameLabel: ReactNode;
    emailAddressLabel: ReactNode;
    phoneNumberLabel: ReactNode;
    submitButtonLabel: ReactNode;
    privacyCollectionNotice: ReactNode;
  };
};

export const FinanceEnquiryForm: FC<FinanceEnquiryFormProps> = ({
  isOpen,
  handleSubmit,
  isSubmitting,
  onClose,
  microcopy,
}) => (
  <BasicModal
    isOpen={isOpen}
    id="financeEnquiryForm"
    title={microcopy.formHeader}
    className={styles.modalWrapper}
    onClose={onClose}
    footer={
      <div className={styles.footer}>
        <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting} fullWidth>
          {microcopy.submitButtonLabel}
        </Button>
        <div className={styles.privacyCollectionNotice}>{microcopy.privacyCollectionNotice}</div>
      </div>
    }
  >
    <Form>
      <section className={styles.formContent}>
        <FormikInput
          type="text"
          size="large"
          name="message"
          label={microcopy.messageLabel!.toString()}
          multiline={5}
          maxLength={100}
          className={styles.messageInput}
          disabled={isSubmitting}
        />
        <h3 className={styles.sectionTitle}>{microcopy.detailSectionTitle}</h3>
        <div className={styles.inputContainer}>
          <FormikInput
            type="text"
            name="firstName"
            label={microcopy.firstNameLabel!.toString()}
            disabled={isSubmitting}
          />
          <FormikInput
            type="text"
            name="lastName"
            label={microcopy.lastNameLabel!.toString()}
            disabled={isSubmitting}
          />
          <FormikInput
            type="email"
            name="emailAddress"
            label={microcopy.emailAddressLabel!.toString()}
            disabled={isSubmitting}
          />
          <FormikInput
            type="tel"
            name="phoneNumber"
            label={microcopy.phoneNumberLabel!.toString()}
            maskType="mobile"
            disabled={isSubmitting}
          />
        </div>
      </section>
    </Form>
  </BasicModal>
);
